/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobViolatedQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyJobViolatedQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyJobViolatedQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobViolatedQueryOperator>): PolicyJobViolatedQueryOperator {
        let obj = Object.assign(new PolicyJobViolatedQueryOperator(), model);
        PolicyJobViolatedQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobViolatedQueryOperator>): PolicyJobViolatedQueryOperator {
        if (!model) return null;
        return PolicyJobViolatedQueryOperator.newInstance(<PolicyJobViolatedQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobViolatedQueryOperator) {
        if (!obj) return;

        models.PolicyJobViolatedQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobViolatedQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyJobViolatedQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Set to true to include only jobs with one or more violated resources
     */
    has_violations: boolean;

}
